import { currencies, type Currency } from '~/constants/currency';

type JSONInvoiceAdjustment = {
  amount: Maybe<string>;
  amount_currency: Maybe<string>;
  description: Maybe<string>;
};

type InvoiceAdjustment = {
  amount: Maybe<string>;
  amountCurrency: Maybe<Currency>;
  description: Maybe<string>;
};

const fromJSON = (jsonInvoice: JSONInvoiceAdjustment): InvoiceAdjustment => ({
  amount: jsonInvoice.amount || null,
  amountCurrency: jsonInvoice.amount_currency ? currencies[jsonInvoice.amount_currency] : null,
  description: jsonInvoice.description,
});

export default InvoiceAdjustment;
export { JSONInvoiceAdjustment, fromJSON };
